/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const BRANDS = {
    CELEBRATIONS: 'CSG',
    FLOWERS: '18F',
    THE_POPCORN_FACTORY: 'TPF',
    FRUIT_BOUQUETS: 'FB',
    BASKETS: '18B',
    CHERYLS: 'CCO',
    STOCKYARDS: 'SY',
    HARRY_AND_DAVID: 'HD',
    SIMPLY_CHOCOLATE: 'SCH',
    BERRIES: 'BRY',
    WOLFERMANS: 'WLF',
    VITAL_CHOICE: 'VC',
    FLORISTS: 'FL',
    PLANTS: 'PLA',
} as const;

export type BRAND_ABRV = typeof BRANDS[keyof typeof BRANDS];

export const brandLogos = {
    [BRANDS.CELEBRATIONS]: 'https://images.contentstack.io/v3/assets/blt72e3f7f9b11dbc4a/blt94dff8fb8fe43616/6810004fff79378eee13c273/celebrations-combined-log.svg?height=32&width=78',
    [BRANDS.FLOWERS]: 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blt70152fe69e54bf98/5f08974aaf2a927f93b3b3ec/18f-logo-v2.svg?height=32&width=78',
    [BRANDS.BASKETS]: 'https://images.contentstack.io/v3/assets/bltc699f5c4977942f7/blt329c48c98c46443f/64111cfcaa6c3f7f594be64c/1800Baskets_Logo_compact.svg?height=32&width=78',
    [BRANDS.BERRIES]: 'https://images.contentstack.io/v3/assets/blt95e0138311135214/bltf0b1021465476e4f/5f08974b0d1d2008538ce15a/SharisLogo_r.svg?height=32&width=78',
    [BRANDS.SIMPLY_CHOCOLATE]: 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blt71adcb0696952e83/5f08974baa5d1801639286b4/sch-logo-v2.svg?height=32&width=78',
    [BRANDS.HARRY_AND_DAVID]: 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blt13b0f02cd71877df/5f08974a8b0e59084c9f7570/hd-logo-v3.svg?height=32&width=78',
    [BRANDS.CHERYLS]: 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blte1e2eb25cfd09fb6/5f08974a91afb901b86d5251/cco-logo-v2.svg?height=32&width=78',
    [BRANDS.FRUIT_BOUQUETS]: 'https://images.contentstack.io/v3/assets/blt95e0138311135214/bltef2e14ec247ab827/5f08974a2cd8e87f92bdd257/fb-logo-v2.svg?height=32&width=78',
    [BRANDS.THE_POPCORN_FACTORY]: 'https://images.contentstack.io/v3/assets/blt95e0138311135214/bltf9903ccf2408c217/5f0897552cd8e87f92bdd25b/tpf-logo-v2.svg?height=32&width=78',
    [BRANDS.VITAL_CHOICE]: 'https://images.contentstack.io/v3/assets/blta522552136812831/blt4ad2e327d32b7758/61b78309a000c90ecc6e1822/VC_Logo_w_tag.svg?quality=100&auto=webp',
    [BRANDS.FLORISTS]: 'https://images.contentstack.io/v3/assets/bltdbb9b0b21e621277/blt43421064ecb770d8/6552559c1bfcdb6ca0dd8760/Florists.com_Logo_Color_OT.svg?height=32&width=78',
    [BRANDS.PLANTS]: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt55247e0014fdfe9f/5f3ec458eb93e224977c1ab8/plants.png?height=32&width=78'
} as Record<BRAND_ABRV, string>

export const fullBrandName = {
    'CSG': 'Celebrations®',
    '18F': '1-800-Flowers®',
    'TPF': 'The Popcorn Factory®',
    '18B': '1-800-Baskets®',
    'HD': 'Harry and David®',
    'FB': 'Fruit Bouquets®',
    'BRY': 'Sharries Berries®',
    'SCH': 'Simply Chocolates®',
    'VC': 'Vital Choice®',
    'WLF': 'Wolfermans®',
    'CCO': 'Cheryls Cookies®',
    'SY': 'Stockyards®',
    'FL': 'Florists®',
    'PLA': 'Plants.com®',
}  as Record<BRAND_ABRV, string>;